import { ENV } from '../config/env';

export const RECAPTCHA_KEY = ENV.recaptchaSiteKey;
